import {DrawingService} from './../../services/drawing.service';
import {Component, OnInit, signal, WritableSignal} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
import {Workorder} from '../../classes/workorder';
import {Project} from '../../classes/project';
import {WorkorderService} from '../../services/workorder.service';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {WorkorderDrawing} from '../../classes/workorder-drawing';
import {Utils} from '../../utils.class';
import {ImageViewerComponent} from '../image-viewer/image-viewer.component';
import {MatDialog} from '@angular/material/dialog';
import {Routenames} from '../../routenames';
import {Title} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs';
import {DrawerService} from '../generic/drawer/drawer.service';
import {Features} from '../../services/auth/features';

@Component({
    selector: 'app-workorder-detail',
    templateUrl: './workorder-detail.component.html',
    styleUrl: './workorder-detail.component.scss'
})
export class WorkorderDetailComponent extends CodaltComponent implements OnInit {
    workorder: Workorder;
    project: Project;
    notASingleDrawingWithEntities = false;
    attachments: WritableSignal<WorkorderDrawing[]> = signal(null);
    drawings: WritableSignal<WorkorderDrawing[]> = signal(null);
    workorderId: number;
    syncing = false;
    loading = false;

    private drawingsSubject = new BehaviorSubject<WorkorderDrawing[]>([]);
    drawings$ = this.drawingsSubject.asObservable();

    constructor(private workorderService: WorkorderService,
                private confirmDialog: ConfirmDialogService,
                private activatedRoute: ActivatedRoute,
                private matDialog: MatDialog,
                private router: Router,
                private title: Title,
                private drawingService: DrawingService,
                private drawerService: DrawerService) {
        super();
    }

    ngOnInit() {
        this.loadWorkorder(this.workorderId);

        this.subscriptions.add(this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.drawerService.close();
            }
        }));
    }

    loadWorkorder(id: number) {
        this.loading = true;
        this.subscriptions.add(this.workorderService.getWorkorder(id).subscribe(workorder => {
            this.loading = false;
            this.workorder = workorder.data;
            this.notASingleDrawingWithEntities = !this.workorder.project.drawings.find(drawing => drawing?.entities_count > 0);

            const attachments = this.workorder.drawings;
            this.attachments.set(attachments);

            const drawings = this.workorder.drawings.filter(drawing => drawing?.drawing_id !== null);

            this.drawingsSubject.next(drawings);


            this.title.setTitle(this.workorder.id_4ps + ' - werkopdracht - TSNed App');
        }, (error: { message: string; }) => {
            console.log(error);
            this.confirmDialog.confirm('Laden mislukt', error?.message ?? 'De werkopdracht kon niet worden geladen.',
                'Opnieuw proberen',
                'Terug').then(() => {
                this.loadWorkorder(id);
            }, () => {
                this.router.navigate([Routenames.WorkOrders]);
            })
        }));

        this.subscriptions.add(this.drawings$.subscribe(drawings => {
            this.drawings.set(drawings);
        }));

    }

    file(woDrawing: WorkorderDrawing) {
        woDrawing.loading = true;

        this.subscriptions.add(
            this.workorderService.getDrawingFile(woDrawing.id).subscribe({
                next: (a) => {
                    const objectURL = URL.createObjectURL(Utils.convertDataUrlToBlob(a.data));
                    woDrawing.loading = false;

                    this.matDialog.open(ImageViewerComponent, {
                        panelClass: 'image-viewer',
                        width: '100vw',
                        height: '100vh',
                        maxWidth: '100vw',
                        hasBackdrop: true,
                        data: {
                            images: [],
                            currentImage: null,
                            ttmStatuses: [],
                            ttmImageDistance: 1,
                            singleImage: Utils.getFileExtension(woDrawing.filename) !== 'pdf' ? objectURL : null,
                            singlePdf: Utils.getFileExtension(woDrawing.filename) === 'pdf' ? objectURL : null
                        }
                    });
                },
                error: () => {
                    woDrawing.loading = false;
                }
            })
        );

    }

    fileExtension(string) {
        return Utils.getFileExtension(string);
    }

    onPenClick() {
        this.router.navigate([`/${Routenames.Projects}/${this.workorder.project_id}`],
            {queryParams: {workorder: this.workorder.id}}
        );
    }

    onBackClick() {
        this.router.navigate([Routenames.WorkOrders], {replaceUrl: true});
        this.drawerService.close();
    }

    executeWorkorder() {
        this.router.navigate([`/${Routenames.Projects}/${this.workorder.project_id}`], {
            queryParams: {executeWorkorder: this.workorder.id}
        });
    }

    openWithRemarkFilter() {
        this.router.navigate([`/${Routenames.Projects}/${this.workorder.project_id}`], {
            queryParams: {withRemark: 'true', workorder: this.workorder.id}
        });
    }

    goToDrawing(projectId: number, drawingId: number) {
        if (this.workorder.drawings.find(d => d.drawing_id === drawingId)?.drawing?.entities_count === 0) {
            return;
        }
        this.router.navigate(
            ['/', Routenames.Projects, projectId],
            {queryParams: {drawing: drawingId, workorder: this.workorder.id}}
        );
    }

    importAttachments() {
        if (!this.syncing) {
            this.syncing = true;
            this.subscriptions.add(this.workorderService.importAttachments(this.workorderId).subscribe((data) => {
                this.loadWorkorder(this.workorderId);
                this.syncing = false;
                this.confirmDialog.confirm('Resultaat synchronisatie', data.message, 'Sluiten', '').then(() => {
                    this.loadWorkorder(this.workorderId);
                });
            }));
        }
    }
}
